import { TypographyStylesProvider, Image } from "@mantine/core";
import React from "react";
import { IconSettings } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const SETTINGS_CONTENT = (
  <TypographyStylesProvider>
    <h1>Settings</h1>
    <p>
      Right now Rizful Node only has a few settings. We will be adding more over
      time. You can access these with...
    </p>
    <DocsButton
      ariaLabel="Settings button"
      text="Settings"
      leftSection={<IconSettings />}
      disabled={false}
    />
    <p> You likely won't need to change these settings very often.</p>
    <SimpleImage h={150} src="docs_images/settings.png" />
    <p>
      Please only mess with the <strong> fee-safety mode</strong> if you are
      experienced with BTC transactions and really want to set your own fees. If
      you disable <strong>fee safety mode</strong>, bad things can happen.{" "}
    </p>

    <p>
      <strong> Fiat</strong> is an experimental kind of currency that is
      (weirdly) printed by each individual country, and people took somewhat
      seriously between roughly 1600 AD and 2009 AD. It tends to gradually lose
      value over time. You could show <strong>Fiat</strong> in Euros if you
      wanted, instead of dollars, with this switch.
    </p>
    <p>
      {" "}
      Here you can also toggle <strong> Bitcoin shown in Satoshis </strong>.
      This switches between showing BTC amounts as either BTC (like 0.0001 BTC)
      or as Satoshis (like 1,000 satoshis).{" "}
    </p>
  </TypographyStylesProvider>
);
